import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Autocomplete from "@mui/material/Autocomplete";
import { TextField } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

import { palette } from "../../theme/palette";

import { filterValueSelector } from "../../reducers/filters/selectors";

import { Text } from "../Base";
import { View } from "../View";

const useStyles = makeStyles({
  section: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "0.938rem",
    paddingBottom: "0.5rem",
  },
  title: {
    fontSize: "1rem",
    fontWeight: "bold",
    lineHeight: "1.25rem",
    color: palette.sunburst,
  },
  autocompleteContainer: {
    marginTop: "6px",
    height: "17px",
    width: "208px",
    borderRadius: "4px",
    backgroundColor: palette.white,
    padding: "2px",
  },
  popupIcon: {
    transform: "rotate(90deg) scale(0.9)",
  },
  autocomplete: {
    "& input": {
      width: "100%",
      textAlign: "left",
      fontSize: "0.9rem",
    },
    "& input::placeholder": {
      color: palette.typography.black.medium,
      opacity: 1,
    },
    "& .MuiAutocomplete-popupIndicator": {
      transform: "none",
    },
  },
  autocompleteItem: {
    marginTop: "-5px",
    marginLeft: "2px",
  },
});

export const FilterAutocomplete = ({ filter, disabled, onChange }) => {
  const styles = useStyles();
  const selectedValue = useSelector(filterValueSelector(filter.field));

  useEffect(() => {
    if (!disabled) return;
    onChange({ ...filter, ...filter.defaultValue });
  }, [filter, disabled, onChange]);

  const handleOnChange = useCallback(
    (e, item) => onChange({ ...filter, ...(item || filter.defaultValue) }),
    [filter, onChange]
  );

  return (
    <View className={styles.section}>
      <Text className={styles.title}>{filter.title}</Text>
      <View className={styles.autocompleteContainer}>
        <Autocomplete
          fullWidth
          className={styles.autocomplete}
          onChange={handleOnChange}
          value={selectedValue}
          popupIcon={<ChevronRightIcon className={styles.popupIcon} />}
          isOptionEqualToValue={({ value: optionValue }, { value } = {}) =>
            (!value && !optionValue) || value === optionValue
          }
          options={filter.values}
          getOptionLabel={({ label }) => label}
          disabled={disabled}
          renderInput={(params) => (
            <TextField
              className={styles.autocompleteItem}
              variant="standard"
              {...params}
              InputProps={{
                ...params.InputProps,
                disableUnderline: true,
              }}
              placeholder={"Please Select Or Type"}
            />
          )}
        />
      </View>
    </View>
  );
};

export default FilterAutocomplete;
